// removed by extract-text-webpack-plugin
module.exports = {"forgotpassword-modal-content":"forgotpassword-modal-content","react-tel-input":"react-tel-input","phone-input2":"phone-input2","verify-btn":"verify-btn","sent-message":"sent-message","show-message":"show-message","noShow":"noShow","showErrMsg":"showErrMsg","password-input":"password-input","password-icon":"password-icon","toggle-text":"toggle-text"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/ForgotPassword/Modal.scss
// module id = iDC5
// module chunks = 0